import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import React from 'react'


const AddMemberScreen = () => {
  return (
    <div className='bg-gray-50 p-2 rounded-md m-6 mt-12'>
        <div className='bg-gray-100 text-darkerPurple'>
            Add Team Member
        </div>
        <div className='mt-8'>
            <div className='text-gray-500'>Enter Name</div>
            <div className='mt-2'>
                <Input
                placeholder="Enter team member's name"
                  className="focus-visible:ring-transparent focus-visible:ring-0 focus:border-darkerPurple hover:border-darkerPurple">
                </Input>
            </div>
        </div>
        <div className='mt-8'>
            <div className='text-gray-500'>Enter Email Address</div>
            <div className='mt-2'>
                <Input
                placeholder="Enter team member's email address"
                className="focus-visible:ring-transparent focus-visible:ring-0 focus:border-darkerPurple hover:border-darkerPurple">
                </Input>
            </div>
        </div>
        <div className='flex justify-center items-center mt-4 mb-4'>
        <Button className="bg-darkPurple text-white hover:bg-darkerPurple">
            Add

        </Button>
        </div>

    </div>
  )
}

export default AddMemberScreen